import { Drawer, Header, Space, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import type { ICreatePaymentMethodFormProps } from './CreatePaymentMethodForm'
import { CreatePaymentMethodForm } from './CreatePaymentMethodForm'
import messages from './messages'

export interface ICreatePaymentMethodFormDrawerProps extends ICreatePaymentMethodFormProps {
  vendorName: string
}

export const CreatePaymentMethodFormDrawer = ({
  open,
  onClose,
  onAirwallexPaymentMethodCreateSuccess,
  onExternalPaymentMethodCreateSuccess,
  vendorName,
  vendorId,
  initialPaymentMethodCategory,
}: ICreatePaymentMethodFormDrawerProps) => {
  const intl = useProcurifyIntl()

  return (
    <Drawer
      drawerOpen={open}
      setDrawerOpen={onClose}
      DrawerProps={{
        renderTitle: () => (
          <Space direction='vertical' size='xsmall'>
            <Header as='h3'>
              {intl.formatMessage(messages.newPaymentMethodTitle)}
            </Header>
            <SubText color='textSecondary'>
              {intl.formatMessage(messages.vendorLabel)} {vendorName}
            </SubText>
          </Space>
        ),
      }}
    >
      {() => (
        <CreatePaymentMethodForm
          open={open}
          vendorId={vendorId}
          onClose={onClose}
          onAirwallexPaymentMethodCreateSuccess={
            onAirwallexPaymentMethodCreateSuccess
          }
          initialPaymentMethodCategory={initialPaymentMethodCategory}
          onExternalPaymentMethodCreateSuccess={
            onExternalPaymentMethodCreateSuccess
          }
        />
      )}
    </Drawer>
  )
}

CreatePaymentMethodFormDrawer.displayName = 'CreatePaymentMethodFormDrawer'
